<template>
  <v-card class="pa-4" flat>
  <v-row>
    <v-col cols="12" xs="12">Hier die Playliste die auch der client erhalten wird.
    </v-col>
    <v-col cols="12" xs="12">
      <pre class="preclass" style="font-size: 10px" v-html="playlistsl"></pre>
    </v-col>
  </v-row>
  </v-card>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'TabPlaylist',
  components: {},
  methods: {
    open: function () {
    },
    onGetPlaylist: function (data) {
      this.playlist = data
      this.playlistsl = this.syntaxHighlight(data)
    },
    syntaxHighlight: function (json) {
      if (typeof json != 'string') {
        json = JSON.stringify(json, undefined, 4);
      }
      return json
    }
  },
  data () {
    return {
      deviceGuid: '',
      playlist: '',
      playlistsl: ''
    }
  },
  mounted () {
    this.deviceGuid = this.$route.params.deviceGuid
    Vue.prototype.$api.loadPlayListByDeviceGuid(this.deviceGuid, this.onGetPlaylist)
  }
}
</script>

<style scoped>
  .preClass {outline: 1px solid #ccc; padding: 5px; margin: 5px; }
  .string { color: green; }
  .number { color: darkorange; }
  .boolean { color: blue; }
  .null { color: magenta; }
  .key { color: red; }

</style>
